export const RIGHT_PANEL_OPEN_KEY = "healo.dayView.rightPanelOpen";
export const DAY_VIEW_SPLIT_LAYOUT_KEY = "healo.dayView.splitLayout";

export function formatLuxonDuration(startAt, endAt) {
  const mins = Math.round(endAt.diff(startAt, "minutes").minutes);
  if (!Number.isFinite(mins) || mins <= 0) return null;
  if (mins < 60) return `${mins} min`;
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return m === 0 ? `${h} h` : `${h} h ${m} min`;
}

export function readDayViewSplitLayout() {
  if (typeof window === "undefined") {
    return undefined;
  }
  try {
    const raw = window.localStorage.getItem(DAY_VIEW_SPLIT_LAYOUT_KEY);
    if (!raw) {
      return undefined;
    }
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") {
      return parsed;
    }
  } catch {
    /* ignore */
  }
  return undefined;
}

export function readRightPanelOpen() {
  if (typeof window === "undefined") {
    return true;
  }
  try {
    return window.localStorage.getItem(RIGHT_PANEL_OPEN_KEY) !== "0";
  } catch {
    return true;
  }
}

export function persistSplitLayout(layout) {
  try {
    window.localStorage.setItem(DAY_VIEW_SPLIT_LAYOUT_KEY, JSON.stringify(layout));
  } catch {
    /* ignore */
  }
}
